
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import { useState, useEffect } from "react";
import { Collapse } from "antd";
import useTranslation from "next-translate/useTranslation";

import { getListCategoryApi, getListQuestionApi } from "@libs/apis/help";

const Help = ({ listCategory, listQuestion }) => {
  const { t } = useTranslation("help");
  const { Panel } = Collapse;

  const [dataSide, setDataSide] = useState([]);
  const [dataDetail, setDataDetail] = useState({});
  const [defaultActiveKey, setDefaultActiveKey] = useState(null);

  useEffect(() => {
    const listResult = listCategory?.map((category) => ({
      title: category?.name,
      key: category?.id,
      children: [],
    }));

    listQuestion?.map((qs) => {
      listResult?.map((category) => {
        if (qs?.guidelineCategory === category?.key) {
          category.children?.push({
            title: qs?.name,
            key: qs?.id,
            content: qs?.content,
          });
        }
      });
    });

    setDataSide(
      listResult?.filter((category) => category?.children?.length > 0),
    );
  }, [listCategory, listQuestion]);

  useEffect(() => {
    if (dataSide?.length > 0) {
      setDataDetail(dataSide?.[0]?.children?.[0]);
      setDefaultActiveKey([dataSide?.[0]?.key]);
    }
  }, [dataSide]);

  return (
    <div className="help">
      <div className="help__header">
        <div className="help__header__content">
          <h1>{t("header")}</h1>
        </div>
      </div>

      <div className="help__content">
        <div className="help__content__side help__content__item">
          {defaultActiveKey && (
            <Collapse
              ghost
              expandIconPosition="end"
              accordion
              defaultActiveKey={[defaultActiveKey]}
            >
              {dataSide?.map((category) => (
                <Panel header={category?.title || ""} key={category?.key || ""}>
                  {category?.children?.length > 0 &&
                    category?.children?.map((qs) => (
                      <p
                        className={
                          dataDetail?.key === qs?.key ? "active-qs" : ""
                        }
                        onClick={() => setDataDetail(qs)}
                        key={qs?.key || ""}
                      >
                        {qs?.title || ""}
                      </p>
                    ))}
                </Panel>
              ))}
            </Collapse>
          )}
        </div>
        <div className="help__content__desc help__content__item">
          <div className="help__content__desc__header">
            <h2>{dataDetail?.title || t("title")}</h2>
          </div>
          <div
            className="help__content__desc__content"
            dangerouslySetInnerHTML={{ __html: dataDetail?.content }}
          />
        </div>
      </div>
    </div>
  );
};

 async function _getServerSideProps() {
  const [getListCategory, getListQuestion] = await Promise.all([
    getListCategoryApi(),
    getListQuestionApi(),
  ]);

  return {
    props: {
      listCategory: getListCategory?.data?.data?.docs || [],
      listQuestion: getListQuestion?.data?.data?.docs || [],
    },
  };
}

export default Help;


    export async function getServerSideProps(ctx) {
        let res = _getServerSideProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/help',
              loaderName: 'getServerSideProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  